import { useEffect } from "react";
import type { Permissions } from "ts-interfaces";
import {
  getActiveDesignFirmId,
  useWorkspaceStore,
} from "ui/utils/workspace/useWorkspaceContext";
import { setGAActiveFirm } from "../libs/analyticsManager";
import { setTeamAnalyticsActiveFirm, setTeamAnalyticsContext } from "./teamAnalytics";

// Mounted once at the app root: the signed-in user's teams for teamAnalytics,
// and the active team on every GA4 event.
export const useTeamAnalyticsContext = (
  uid: string | null,
  permissions: Permissions | null | undefined,
) => {
  const storedActive = useWorkspaceStore((s) => (uid ? s.activeIdByUid[uid] : undefined));
  useEffect(() => setTeamAnalyticsContext(uid, permissions), [uid, permissions]);
  useEffect(() => {
    const firmId = uid ? getActiveDesignFirmId(uid) : null;
    setGAActiveFirm(firmId);
    setTeamAnalyticsActiveFirm(firmId);
  }, [uid, storedActive]);
};
